import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Skeleton from '@mui/material/Skeleton'
import { CARD_PADDING } from '@/theme/cardTokens'

interface CardSkeletonProps {
  showChips?: boolean
}

export default function CardSkeleton({ showChips = false }: CardSkeletonProps) {
  return (
    <Card>
      <Box
        sx={{
          p: CARD_PADDING.compact,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="55%" height={20} />
          <Skeleton variant="text" width="75%" height={16} />
          {showChips && (
            <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5 }}>
              <Skeleton variant="rounded" width={48} height={18} />
              <Skeleton variant="rounded" width={64} height={18} />
            </Box>
          )}
        </Box>
        <Skeleton variant="circular" width={20} height={20} />
      </Box>
    </Card>
  )
}
